const getPropertyValueByStringPath = (obj, path, defaultValue) => {
    const temp = path.split('.').reduce((value, key) => {
        if (!!value && typeof value === 'object') {
            return value[key];
        }
        return '';
    }, obj);
    return temp === undefined || temp === '' ? defaultValue : temp;
};
export default getPropertyValueByStringPath;
